/* CUCA — o mínimo de JS: galeria da PDP, o relógio e o countdown do drop. */
document.addEventListener('click', function (e) {
  var t = e.target.closest('[data-thumb]');
  if (!t) return;
  var main = document.querySelector('[data-pdp-main]');
  if (!main) return;
  main.src = t.dataset.thumb;
  document.querySelectorAll('[data-thumb]').forEach(function (b) { b.setAttribute('aria-current', b === t ? 'true' : 'false'); });
});
var p2 = function (n) { return String(n).padStart(2, '0'); };
(function hora() {
  var els = document.querySelectorAll('[data-hora]');
  if (!els.length) return;
  function tick() {
    var d = new Date(), t = p2(d.getHours()) + ':' + p2(d.getMinutes());
    els.forEach(function (el) { el.textContent = t; });
  }
  tick(); setInterval(tick, 10000);
})();
(function drop() {
  document.querySelectorAll('[data-countdown]').forEach(function (root) {
    var alvo = new Date(root.getAttribute('data-countdown')).getTime();
    if (isNaN(alvo)) return;
    var d = root.querySelector('[data-cd-d]'), h = root.querySelector('[data-cd-h]'),
        m = root.querySelector('[data-cd-m]'), s = root.querySelector('[data-cd-s]');
    function tick() {
      var dif = Math.max(0, alvo - Date.now());
      var dd = Math.floor(dif / 864e5); dif -= dd * 864e5;
      var hh = Math.floor(dif / 36e5); dif -= hh * 36e5;
      var mm = Math.floor(dif / 6e4); dif -= mm * 6e4;
      var ss = Math.floor(dif / 1e3);
      if (d) d.textContent = p2(dd);
      if (h) h.textContent = p2(hh);
      if (m) m.textContent = p2(mm);
      if (s) s.textContent = p2(ss);
    }
    tick(); setInterval(tick, 1000);
  });
})();
